import type { Client } from '../../caseload/types';
import type { User } from '../../users/types/rbac';

/**
 * `User.name` for staff is the preferred display label. Persist it as a FHIR legal
 * name only for client (Patient) saves.
 */
export function applyClientLegalNameToUserUpdates(
  updates: Partial<User>,
  opts: {
    isClientSave: boolean;
    editedClient: Pick<Client, 'firstName' | 'lastName' | 'email' | 'phone'> | null;
    fallbackName: string;
    fallbackEmail?: string;
    fallbackPhone?: string;
  },
): Partial<User> {
  if (!opts.isClientSave || !opts.editedClient) return updates;
  const fullName =
    [opts.editedClient.firstName, opts.editedClient.lastName].filter(Boolean).join(' ')
    || opts.fallbackName;
  return {
    ...updates,
    name: fullName,
    email: opts.editedClient.email ?? opts.fallbackEmail,
    phone: opts.editedClient.phone ?? opts.fallbackPhone,
  };
}
